import PlaceholderImage from "../../images/png/video-placeholder.png";

export const RatedTubeDummyData = [
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "single",
    noOfTracks: "1",
    releaseDate: "11 Aug 2024",
    status: "released"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "album",
    noOfTracks: "15",
    releaseDate: "11 Aug 2024",
    status: "processing"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "single",
    noOfTracks: "1",
    releaseDate: "11 Aug 2024",
    status: "inactive"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "single",
    noOfTracks: "1",
    releaseDate: "11 Aug 2024",
    status: "released"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "single",
    noOfTracks: "1",
    releaseDate: "11 Aug 2024",
    status: "released"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "single",
    noOfTracks: "1",
    releaseDate: "11 Aug 2024",
    status: "released"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "album",
    noOfTracks: "15",
    releaseDate: "11 Aug 2024",
    status: "processing"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "single",
    noOfTracks: "1",
    releaseDate: "11 Aug 2024",
    status: "inactive"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "single",
    noOfTracks: "1",
    releaseDate: "11 Aug 2024",
    status: "released"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "single",
    noOfTracks: "1",
    releaseDate: "11 Aug 2024",
    status: "released"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "single",
    noOfTracks: "1",
    releaseDate: "11 Aug 2024",
    status: "released"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "album",
    noOfTracks: "15",
    releaseDate: "11 Aug 2024",
    status: "processing"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "single",
    noOfTracks: "1",
    releaseDate: "11 Aug 2024",
    status: "inactive"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "single",
    noOfTracks: "1",
    releaseDate: "11 Aug 2024",
    status: "released"
  },
  {
    coverImage: PlaceholderImage,
    title: "The Vibe",
    artists: "Vectra, Sammy T Beatz",
    type: "single",
    noOfTracks: "1",
    releaseDate: "11 Aug 2024",
    status: "released"
  }
];
